// src/components/GoogleTag.js
import { useEffect } from 'react';
import { ADS_ID, GA4_ID } from '../lib/analytics';
import { readConsent, setDefaultConsent, applyConsent, onConsentChange } from '../lib/consent';

/**
 * Ładuje gtag.js i konfiguruje oba konta:
 *  - Google Ads (konwersje zakupu),
 *  - GA4 (lejek: wejście → demo → cennik → zakup), jeśli ustawiono REACT_APP_GA4_ID.
 * Odsłony w SPA wysyła PageViewTracker, dlatego wyłączamy automatyczne page_view.
 *
 * Skrypt pobieramy DOPIERO po zgodzie użytkownika. Powody są dwa:
 *  - RODO: przed zgodą nie wysyłamy nic do Google, także adresu strony,
 *  - szybkość: same skrypty Google to ok. 347 kB, czyli ponad połowa wagi
 *    strony głównej. Kto nie wyrazi zgody, w ogóle ich nie pobiera.
 * Zgoda udzielona w banerze uruchamia pomiar od razu, bez przeładowania strony.
 */
const GoogleTag = () => {
  useEffect(() => {
    // Kolejka gtag musi istnieć od początku - zdarzenia sprzed zgody trafią
    // do dataLayer i zostaną przetworzone dopiero po wczytaniu skryptu.
    window.dataLayer = window.dataLayer || [];
    if (!window.gtag) {
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
    }

    setDefaultConsent();

    let loaded = false;
    const loadTag = () => {
      if (loaded || window.__gtagScriptLoaded) return;
      loaded = true;
      window.__gtagScriptLoaded = true;

      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID || ADS_ID}`;
      script.async = true;
      document.head.appendChild(script);

      window.gtag('js', new Date());
      if (ADS_ID) window.gtag('config', ADS_ID);
      if (GA4_ID) window.gtag('config', GA4_ID, { send_page_view: false });
    };

    const saved = readConsent();
    if (saved) applyConsent(saved);
    if (saved === 'granted') loadTag();

    // Reakcja na decyzję w banerze - bez czekania na kolejne wejście.
    return onConsentChange(event => {
      if (event.detail === 'granted') loadTag();
    });
  }, []);

  return null;
};

export default GoogleTag;
